import { store } from 'Store/store.index';
import { USER_SIGN_IN_FAILED, USER_SIGN_IN_SUCCESS } from 'Store/constants';

export default class AIPluginUserFns{
  constructor(fnMap){
    this.fnMap = fnMap;

    this.addFn_loginIn = this.addFn_loginIn.bind(this);
    //this.addFn_onListenUserEvent = this.addFn_onListenUserEvent.bind(this);
    this.addFn_getUser = this.addFn_getUser.bind(this);
    this.addFn_getUserJWT = this.addFn_getUserJWT.bind(this);
  }
  registerFn(){
    this.addFn_loginIn();
    this.addFn_getUser();
    this.addFn_getUserJWT();
    //this.addFn_onListenUserEvent();
  }

  addFn_loginIn(){
    this.fnMap['loginIn'] = ({ /* method, data,  */id, resolve })=>{
      const { hasSignIn } = store.userStore;
      if(hasSignIn){
        resolve({ret:0})
        return;
      }

      let cleanFn = ()=>{
        store.appStore.removeAppEventListener(USER_SIGN_IN_SUCCESS,  window[id+"_success"])
        store.appStore.removeAppEventListener(USER_SIGN_IN_FAILED, window[id+"_failed"])
        delete window[id+"_success"];
        delete window[id+"_failed"];
      }
      window[id+"_success"] = function(){
        cleanFn()
        resolve({ret:0})
      }
      window[id+"_failed"] = function(){
        cleanFn()
        resolve({ret:999})
      }
      store.appStore.addAppEventListener(USER_SIGN_IN_SUCCESS, window[id+"_success"])
      store.appStore.addAppEventListener(USER_SIGN_IN_FAILED, window[id+"_failed"])
      // store.userStore.loginIn()
      store.userStore.signUp()
    }
  }

  addFn_getUser(){
    this.fnMap['getUser'] = async({ /* method, data, id, */ resolve })=>{
      const { hasSignIn } = store.userStore;
      if(!hasSignIn){
        resolve({ret:210007})
        return;
      }
      const {userInfo} = store.userStore;
      const {cUserID, userEmail, firstname, lastname, full_name} = userInfo
      let token = await store.userStore.getToken();
      let userData = {
        token,
        info:{
          email: userEmail,
          username: full_name,
          userid: cUserID,
          loginFrom: 'online'
        }
      }
      firstname && (userData.info['firstname'] = firstname)
      lastname && (userData.info['lastname'] = lastname)
      resolve({ret:0, data: userData})
    }
  }
  addFn_getUserJWT(){
    this.fnMap['getUserJWT'] = async( { /* method, data, id, */ resolve })=>{
      const { hasSignIn } = store.userStore;
      if(!hasSignIn){
        resolve({ret:210007})
        return;
      }
      let from = 'FoxitAi';
      let result = await store.userStore.getUserJWT(from);
      if(!result || !result.data || !result.data.jwt){
        resolve({ret:210007})
        return;
      }
      
      resolve({ret:0, data: {jwt: result.data.jwt}})
    }
  }
}